import { useMemo } from "react";
import { Anchor, Paper, Stack, Text, Title } from "@mantine/core";
import dayjs from "dayjs";

import CopyableField from "./CopyableField";
import ObservationMetadataRow from "./ObservationMetadataRow";

const TIMESTAMP_FORMAT = "MMM D, YYYY h:mm A";

interface ObservationMetadataCardProps {
  reporterName: string;
  reporterEmail: string;
  createdAt: string;
  updatedAt: string;
  canViewSessionRecording: boolean;
  onViewSessionRecording: () => void;
}

export default function ObservationMetadataCard({
  reporterName,
  reporterEmail,
  createdAt,
  updatedAt,
  canViewSessionRecording,
  onViewSessionRecording,
}: ObservationMetadataCardProps) {
  const submittedLabel = useMemo(
    () => dayjs(createdAt).format(TIMESTAMP_FORMAT),
    [createdAt]
  );
  const updatedLabel = useMemo(
    () => dayjs(updatedAt).format(TIMESTAMP_FORMAT),
    [updatedAt]
  );

  return (
    <Paper withBorder p="md">
      <Title order={4} mb="md">
        Metadata
      </Title>
      <Stack gap="md">
        <CopyableField label="Reporter" value={reporterName} />
        <CopyableField label="Email" value={reporterEmail} />
        <ObservationMetadataRow label="Submitted">
          <Text size="sm">{submittedLabel}</Text>
        </ObservationMetadataRow>
        <ObservationMetadataRow label="Last updated">
          <Text size="sm">{updatedLabel}</Text>
        </ObservationMetadataRow>
        {canViewSessionRecording && (
          <ObservationMetadataRow label="Session recording">
            <Anchor
              component="button"
              type="button"
              size="sm"
              ta="left"
              onClick={onViewSessionRecording}
            >
              View session recording
            </Anchor>
          </ObservationMetadataRow>
        )}
      </Stack>
    </Paper>
  );
}
